import React from "react";
import { WorkflowIcon, MapIcon, MessagesSquareIcon, RepeatIcon } from "lucide-react";
import { CTAButton } from "../CTAButton";
import { SectionHeading } from "../SectionHeading";
import { expectations } from "../../data/content";
const icons = [WorkflowIcon, MapIcon, MessagesSquareIcon, RepeatIcon];
export function ExpectationsSection() {
  return <section className="bg-ink px-4 py-16 sm:py-24" data-id="element-134" data-mp="399y0i0n5azwn">
      <div className="mx-auto max-w-5xl" data-id="element-135" data-mp="3e5wi95dyxjo3">
        <SectionHeading kicker="What you can expect" title="A practical resource for dental professionals" intro="Rather than a single checklist or a pile of unrelated materials, the system organizes the review process into six complementary areas." data-id="element-136" data-mp="3e90soki11bn7" />

        <ul className="mt-12 grid gap-x-10 gap-y-8 sm:grid-cols-2" data-id="element-137" data-mp="3s5xsvck1c5gr">
          {expectations.map((e, i) => {
          const Icon = icons[i];
          return <li key={e.title} className="flex gap-4" data-id="element-138" data-mp="1xtr5zghs408m" data-mpi={i}>
                <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-2xl bg-brand/15" data-id="element-139" data-mp="6juxqgc9ua1u">
                  <Icon className="h-6 w-6 text-brand" aria-hidden="true" data-id="element-140" data-mp="1tegel5by4a7" />
                </span>
                <div data-id="element-141" data-mp="3sz65dh7dfavf">
                  <h3 className="text-xl font-extrabold text-white" data-id="element-142" data-mp="3t0habkcjyoo4">{e.title}</h3>
                  <p className="mt-1 text-[17px] leading-relaxed text-white/70" data-id="element-143" data-mp="3oydvqmul73ym">{e.text}</p>
                </div>
              </li>;
        })}
        </ul>

        <p className="mx-auto mt-10 max-w-2xl text-center text-lg font-semibold text-white/85" data-id="element-144" data-mp="pgcvbedsx460">
          The goal isn't to eliminate clinical uncertainty. It's to help you approach important decisions with a more
          organized process.
        </p>

        <div className="mt-10" data-id="element-145" data-mp="bi660mmx4chy">
          <CTAButton label="Start my structured workflow" data-id="element-146" data-mp="bl23k9uusz5v" />
        </div>
      </div>
    </section>;
}